import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import { AccountPromotion } from './iam/AccountPromotion';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
//import { CareCenterSummary } from './carecenter/CareCenterSummary'
import { PatientSummary } from './patient/PatientSummary'
import { Stack } from '@mui/material';

import { useAuth } from "react-oidc-context";
import { CompleteProfileChip } from './profile/CompleteProfileChip'
import Container from '@mui/material/Container';

import { useAuthProfile } from "../app/hooks"
import { showProfile } from "../features/dialogSlice";
import Button from '@mui/material/Button';

import { getSearchByCoordinates } from "../features/searchSlice";
//import { MessageProfile } from './MessageProfile'
import { AISummary } from "./AI/AISummary"
import { /*getProfileFromID,*/ LeftSideComponentWithOptions, setCenter, setPublicPinClicked } from "../features/dataProcessingSlice"
import { activateMarker } from '../features/activeMarkers';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';
import { CircularProgressCentered } from '../app/components/sharedcomponents';
import { InitialDataProcessingState } from '../features/dataProcessingSlice'
//import { RootState } from '@reduxjs/toolkit/query';
import { RootState, useTypedSelector } from '../app/store';
//import { AnalyticsChannelSummary, ChatUserNotFound } from './messaging/ChatCardMM';
//import {RoootState} from '../App/store'
import { ResourceMini } from './resources/ResourceMini';
import { NavMini } from './navbar/NavMini';
//import { useCreateOrJoinOpenChatMutation } from '../features/ChatSlice';
import { OpenChannelMain } from './messaging/OpenChannelMain';

import { StorySearchSummary } from './search/StorySearchSummary'
import PlaceIcon from '@mui/icons-material/Place';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import Dialog from '@mui/material/Dialog';
import { QueryStatus } from '@reduxjs/toolkit/query';
import { selectLastgetSearchByStoryStatusArgsAndData } from '../AppBody';
import { Condition, coonditionContext } from "../index";
//import { ClinicalTrialsSignupCard } from './massive-bio/ClinicalTrialsSignupCard';
import { LinkPhoneNumberCard } from './iam/LinkPhoneNumberCard';

export const GetAnnouncementsChannelUrlForEnvironment: () => { channelName: string, channelUrl: string } = () => {
  //return 'Patient_Connect_Announcements'
  return { channelName: 'Patient Connect Announcements', channelUrl: 'Patient_Connect_Announcements' }
  // const environmentNODE_ENV: string = process.env.NODE_ENV || 'development';
  // const environmentREACT_APP_ENV: string = process.env.REACT_APP_ENV || 'test'
  // const url = environmentNODE_ENV !== 'development' && environmentREACT_APP_ENV !== 'test'? 'prod_announcements':'test_announcements'
  // return url
}

//export function LeftDrawer1(bottomSheetRef: any) {
export const LeftDrawer1: React.FC<{ bottomSheetRef?: any }> = ({ bottomSheetRef }) => {
  const dispatch = useDispatch<any>();
  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  const auth = useAuth()
  const { authStatus, profile: loggedInProfile, isLoading: isAuthProfileLoading,  isProfileSuccess, isSuccess, isError, error, sub } = useAuthProfile()
  // const [SetChat, { isLoading: isLoadingSetChat, isSuccess: isSuccessSetChat, isError: isErrorSetChat, data: setChatData, originalArgs //isError: isErrorSetChat, error: errorSetChat, reset 
  // }] = useCreateOrJoinOpenChatMutation()
  //const { data: profiles, isLoading } = useGetProfilesPinDataForDefaultPointQuery(); - not used
  const AIState_publicPinClicked = useTypedSelector((state: RootState) => state.dataProcessing.publicPinClicked)
  const navigate = useNavigate()
  const [openLoginDialog, setOpenLoginDialog] = React.useState(false)
  const leftSideComponentWithOptionsState: LeftSideComponentWithOptions = useTypedSelector(
    (state: RootState) => state.dataProcessing.leftSideComponentWithOptions
  );
  const AIState_aiProfileOptions = leftSideComponentWithOptionsState.options

  const lastgetSearchByStoryStatusArgsAndData = useSelector((state: any) => selectLastgetSearchByStoryStatusArgsAndData(state));


  const searchState = useSelector((state: any) => state.search, (prev, next) => {
    if (!next.center) return true
    if (!prev.center) return false
    return prev.center.lat === next.center.lat && prev.center.lng === next.center.lng
  });


  // //need to do this to get user set up after loggin in. the announcement chat is created and the Guest user (361) is too for unautheticeted 
  // React.useEffect(() => {
  //   if (isSuccess) {
  //     //.const idToUseForSendbird =   authStatus === 'unauthenticated'? 11111: loggedInProfile.id
  //     SetChat({ ids: [loggedInProfile.id], ...GetAnnouncementsChannelUrlForEnvironment(), channelType: "announcements" })
  //   }
  // }, [isSuccess])

  React.useEffect(() => {
    if (lastgetSearchByStoryStatusArgsAndData?.data?.length > 0) {//searchStoryState.storySearch.data.length > 0) {
      const element = document.getElementById('storySearchResult') as HTMLElement;
      if (element) {
        //console.log("test")
        element.scrollIntoView(true);
      }
    }
  }, [lastgetSearchByStoryStatusArgsAndData?.status === QueryStatus.fulfilled]) //searchStoryState.storySearch.complete]); 

  const center = searchState.center;
  if (searchState.status.isUnInitialized) {
    //    return null
  }
  const showAccountPromotion = authStatus !== 'authenticated' //&& ((leftSideComponentWithOptionsState.options?.showAccountPromotion)??false)

  const handleHomeClick = () => {
    if (!loggedInProfile || !loggedInProfile.id) {
      return
    }
    dispatch(getSearchByCoordinates({ lat: loggedInProfile?.lat, lng: loggedInProfile?.lng }));
    //leocenterno need the below ceters probobly by showing the marker on the map dispatch(setCenter({ lat: profile.lat, lng: profile.lng }))
    dispatch(activateMarker({ id: loggedInProfile?.id, disableHover: true }))
    dispatch(setPublicPinClicked(loggedInProfile?.id))
    //dispatch(getProfileFromID(profile.id))
  }

  function handleLocatePinClick() {
    dispatch(getSearchByCoordinates({ lat: loggedInProfile.lat, lng: loggedInProfile.lng }));
    dispatch(activateMarker({ id: loggedInProfile.id, disableHover: true }))
  }

  function handleEditPinClick() {
    dispatch(showProfile({ isForced: true }))
  }


  // if (isError) {
  //   const profileError = error.data ? error.data.error : error.message ?? ''
  //   return (<>{profileError}</>)
  // }
  if (isAuthProfileLoading)
    return (<CircularProgressCentered />)

  const noStory = loggedInProfile ? !loggedInProfile?.comment?.trim() : true
  const showProfileToComplete: boolean = (isProfileSuccess && loggedInProfile) ? !loggedInProfile.is_completed : true //loggedInProfile.zipcode === null || loggedInProfile.communicate_with_others === null || !loggedInProfile.provide_information_for_research === null || !loggedInProfile.receive_emails === null : false

  //const showAISummary = AIState_publicPinClicked ? ((!noStory && !showProfileToComplete) ) : false
  const showAISummary = AIState_publicPinClicked
  // const environmentNODE_ENV: string = process.env.NODE_ENV || 'development';
  // const environmentREACT_APP_ENV: string = process.env.REACT_APP_ENV || 'test'
  if (showAISummary) {
    return (<AISummary bottomSheetRef={bottomSheetRef} pinToUse={AIState_publicPinClicked} showAccountPromotion={showAccountPromotion} showMessageButton={AIState_aiProfileOptions?.showMessageButton} showViewUserStoryAnalytics={AIState_aiProfileOptions?.showViewUserStoryAnalytics} />)
  } else {
    //the culprit was the box below
    return (
      <Box sx={{ display: 'flex', borderRight: '1px solid', borderColor: '#EEEEEE', overflow: 'auto', width: '100%', height: { xs: 'auto', sm: 'auto', md: 'calc(100vh - 80px)' }, pt: 1 }}>
        <Stack direction="column" spacing={2.5} sx={{ width: '100%', px: 2 }}>
          {authStatus == 'authenticated' &&
            <>
              <Stack direction="row" sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <Stack direction="row" gap={1.5} alignItems="center">
                  <Avatar sx={{ width: 34, height: 34, bgcolor: '#656EFF', fontSize: 14, fontWeight: 600 }}>
                    {loggedInProfile?.name_public?.[0]?.toUpperCase() ?? '?'}
                  </Avatar>
                  <Typography variant="subtitle1" sx={{ fontSize: { xs: 15, md: 16 }, fontWeight: 600, color: '#1a1a2e' }}>
                    Hi{`${loggedInProfile ? ', ' + loggedInProfile.name_public : ''}`}
                  </Typography>
                </Stack>
                <Button
                  sx={{ color: '#656EFF', borderColor: '#E0DEFF', borderRadius: 2, fontSize: 13, fontWeight: 500, textTransform: 'none', px: 1.5 }}
                  onClick={handleHomeClick}
                  variant="outlined"
                  disableElevation
                  endIcon={<ArrowForwardIosIcon sx={{ fontSize: '12px !important' }} />}
                >
                  My Profile
                </Button>
              </Stack>
              <Divider sx={{ borderColor: '#F0F0F0' }} />
            </>
          }

          {authStatus == 'unauthenticated' &&
            <Stack direction="column" gap={2} sx={{ p: 2.5, backgroundColor: '#F5F3FF', borderRadius: 3, border: '1px solid #E8E4FF', boxShadow: '0 2px 8px rgba(101, 110, 255, 0.08)' }}>
              <Typography variant="subtitle1" sx={{ fontSize: { xs: 15, md: 16 }, fontWeight: 700, color: '#1a1a2e' }}>
                Get Started
              </Typography>
              <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6 }}>
                Sign in or sign up to add your pin, connect with others with similar experiences, access resources, and more.
              </Typography>
              <Button
                variant="contained"
                sx={{ color: 'white', backgroundColor: '#656EFF', borderRadius: 2, textTransform: 'none', fontWeight: 600, alignSelf: 'flex-start', px: 2.5, boxShadow: '0 2px 8px rgba(101,110,255,0.25)' }}
                onClick={() => { navigate('/signin') }}
                disableElevation
              >
                Sign in
              </Button>
            </Stack>
          }

          {(authStatus == 'authenticated' && !loggedInProfile?.phone) && <LinkPhoneNumberCard />}
          <StorySearchSummary />

          {isProfileSuccess &&
            <Stack direction="column" gap={1.5}>
              <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="overline" sx={{ color: '#9E9E9E', letterSpacing: 1.2, fontSize: 11, fontWeight: 600, lineHeight: 1 }}>
                  My Pin
                </Typography>
                {(authStatus == 'authenticated' && loggedInProfile?.is_completed) &&
                  <Stack direction="row" gap={0.5} alignItems="center">
                    <PlaceIcon sx={{ color: '#656EFF', fontSize: 16 }} />
                    <Typography variant="body2" sx={{ color: '#777777', fontSize: 13 }}>
                      {loggedInProfile.formattedsearchterm}
                    </Typography>
                  </Stack>
                }
                {authStatus == 'unauthenticated' &&
                  <Button
                    variant="outlined"
                    sx={{ borderRadius: 2, color: '#656EFF', borderColor: '#E0DEFF', textTransform: 'none', fontSize: 13, fontWeight: 500, px: 1.5 }}
                    onClick={() => { navigate('/signin/?redirect=/Profile') }}
                    disableElevation
                    startIcon={<AddLocationAltIcon sx={{ fontSize: 16 }} />}
                  >
                    Add My Pin
                  </Button>
                }
              </Stack>
            </Stack>
          }

          {(authStatus == 'authenticated' && isProfileSuccess && !loggedInProfile?.is_completed) &&
            <Stack direction="column" gap={2} sx={{ p: 2.5, backgroundColor: '#F5F3FF', borderRadius: 3, border: '1px solid #E8E4FF', boxShadow: '0 2px 8px rgba(101, 110, 255, 0.08)' }}>
              <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6 }}>
                Looking for members nearby? Add your pin to get started!
              </Typography>
              <Button
                variant="contained"
                sx={{ borderRadius: 2, backgroundColor: '#656EFF', textTransform: 'none', fontWeight: 600, alignSelf: 'flex-start', px: 2.5, boxShadow: '0 2px 8px rgba(101,110,255,0.25)' }}
                onClick={handleEditPinClick}
                disableElevation
                startIcon={<AddLocationAltIcon />}
              >
                Add My Pin
              </Button>
            </Stack>
          }

          {(authStatus == 'authenticated' && isProfileSuccess && loggedInProfile?.is_completed) &&
            <Stack direction="row" gap={1}>
              <Button
                sx={{ flex: 1, color: '#46497C', backgroundColor: '#F5F3FF', borderRadius: 2, fontSize: 13, fontWeight: 500, textTransform: 'none', borderColor: '#E8E4FF', py: 1 }}
                onClick={handleLocatePinClick}
                variant="outlined"
                disableElevation
                startIcon={<PlaceIcon sx={{ fontSize: 18 }} />}
              >
                Locate
              </Button>
              <Button
                sx={{ flex: 1, color: '#46497C', backgroundColor: '#F5F3FF', borderRadius: 2, fontSize: 13, fontWeight: 500, textTransform: 'none', borderColor: '#E8E4FF', py: 1 }}
                onClick={handleEditPinClick}
                variant="outlined"
                disableElevation
                startIcon={<EditIcon sx={{ fontSize: 18 }} />}
              >
                Edit Pin
              </Button>
            </Stack>
          }

          {center && <PatientSummary loggedInProfile={loggedInProfile} />}

          <Typography variant="overline" sx={{ color: '#9E9E9E', letterSpacing: 1.2, fontSize: 11, fontWeight: 600, lineHeight: 1 }}>
            Community Journal
          </Typography>
          <OpenChannelMain channelUrl={GetAnnouncementsChannelUrlForEnvironment().channelUrl} />

          <ResourceMini />

          <Divider sx={{ borderColor: '#F0F0F0' }} />

          <Typography variant="overline" sx={{ color: '#9E9E9E', letterSpacing: 1.2, fontSize: 11, fontWeight: 600, lineHeight: 1, textAlign: 'center' }}>
            Explore Patient Connect
          </Typography>
          <NavMini />

          <Typography variant="caption" sx={{ color: '#C0C0C0', textAlign: 'center', mt: 0 }}>
            Version: {process.env.REACT_APP_VERSION} {process.env.REACT_APP_BUILD_TIME ? new Date(process.env.REACT_APP_BUILD_TIME).toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'short' }) : 'Unknown'}
          </Typography>

        </Stack>
      </Box>
    );
  }

}